import { createContext } from "react";
import { Domains } from "../data/Domains";
import { NotificationTypes } from "../data/NotificationTypes";


type VillageConsoleContextProps = {
    
    availableDomains: Domains[ ],
    domain: Domains,
    functionKey: string | null,
    notificationMessage: string,
    notificationType: NotificationTypes,
    readonlyDomains: Domains[ ],
    setAvailableDomains: ( _: Domains[] ) => void,
    setDomain: ( _: Domains ) => void,
    setFunctionKey: ( _: string|null ) => void,
    setNotificationText: ( _: string ) => void,
    setNotificationType: ( _: NotificationTypes ) => void,
    setReadonlyDomains: ( _: Domains[] ) => void

};

const VillageConsoleContext = createContext<VillageConsoleContextProps>({

    availableDomains: [ ],
    domain: Domains.Bma,
    functionKey: null,
    notificationMessage: '',
    notificationType: NotificationTypes.Success,
    readonlyDomains: [ ],
    setAvailableDomains: ( _: Domains[] ) => {},
    setDomain: ( _: Domains ) => {},
    setFunctionKey: ( _: string | null ) => {},
    setNotificationText: ( _: string )  => {},
    setNotificationType: ( _: NotificationTypes ) => {},
    setReadonlyDomains: ( _: Domains[] ) => {}

});

export default VillageConsoleContext;
